<template>
  <AppLink :to="newLink">
    <div :class="['chip', { active: tag.isActive }]">
      <span class="name">{{ tag.tag_name }}</span>
      <span class="count">{{ tag.tours_count }}</span>
    </div>
  </AppLink>
</template>

<script lang="ts" setup>
  import { type TagWithActive } from '@/shared/models';

  interface Props {
    tag: TagWithActive;
  }

  const props = defineProps<Props>();

  const newLink = props?.tag?.category_slug ? `/tours/russia/category/${props.tag.category_slug}/` : '';
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography';

  .chip {
    padding: 6px 12px;
    border-radius: 8px;
    background-color: var(--alias-color-background-subtle);
    white-space: nowrap;
    cursor: pointer;
  }

  .name,
  .count {
    @include typography.base-300-300-medium;
  }

  .name {
    color: var(--alias-color-text-default);
  }

  .count {
    margin-left: 4px;
    color: var(--alias-color-text-subtler);
  }

  .active {
    background: var(--alias-color-background-inverse);

    .name {
      color: var(--alias-color-text-inverse);
    }
  }

  a {
    text-decoration: none;
  }
</style>
